import { render, staticRenderFns } from "./EventCardList.vue?vue&type=template&id=6c7f2294"
import script from "./EventCardList.vue?vue&type=script&lang=js"
export * from "./EventCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports